<template>
  <v-container fluid grid-list-lg>

    <v-dialog v-model="detail" fullscreen dark hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark flat>
          <v-toolbar-title>{{ work.works_details_title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark flat @click="detail = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg3>
            <v-img :src="works_details_img" aspect-ratio="1" contain="true" class="work-detail-img"></v-img>
          </v-flex>
          <v-flex xs12 sm6 md8 lg9>
            <div class="pa-3">
              <div class="title">{{ $t("title") }}</div>
              <div class="subheading">{{ work.works_details_title }}</div>
            </div>
            <v-divider></v-divider>
            <div class="pa-3">
              <div class="title">{{ $t("works-code") }}</div>
              <div class="subheading">{{ work.works_code }}</div>
            </div>
            <v-divider></v-divider>
            <div class="pa-3">
              <div class="title">{{ $t("price") }}</div>
              <div class="subheading">¥{{ work.works_price }}</div>
            </div>
            <v-divider></v-divider>
            <div class="pa-3">
              <div class="title">{{ $t("detail") }}</div>
              <div class="subheading">{{ work.works_details_introduction }}</div>
            </div>
            <v-divider></v-divider>
            <div class="pa-3">
              <div class="title">{{ $t("creator") }}</div>
              <div class="subheading">{{ work.creators_first_name }} {{ work.creators_last_name }}</div>
            </div>
            <v-divider></v-divider>
            <div class="pa-3">
              <v-btn color="dark darken-1" outline round @click="addItemToCart(work.works_id)"><v-icon>shopping_cart</v-icon> {{ $t("add-to-cart") }}</v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-layout row wrap class="ss-layout">
      <v-flex xs12 sm6 md4 lg3>
        <v-card>
          <v-responsive :aspect-ratio="1/1">
            <v-img :src="creators_img" aspect-ratio="1"></v-img>
          </v-responsive>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md8 lg9>
        <div class="creators-name">{{ creator.creators_first_name }} {{ creator.creators_last_name }}</div>
        <v-divider></v-divider>
        <div class="creators-detail">{{ creator.creators_details_introduction }}</div>           
      </v-flex>
    </v-layout>

    <div class="text-xs-center" v-if="length > 1">
      <v-pagination
        v-model="page"
        :length="length"
        total-visible=5
        color="#000"
        @input="nextPage"
      ></v-pagination>
    </div>

    <v-layout row wrap class="ss-layout">
      <v-flex xs12 sm6 md4 lg3 xl2 v-for="(work, key) in works" :key="key" @click="openDetail(key)">
        <v-card class="ss-card">
          <v-responsive :aspect-ratio="1/1">
            <v-img :src="'/service/img/public/works/' + work.works_img" aspect-ratio="1" class="ss-card-img"></v-img>
          </v-responsive>
          <div class="ss-card-title2 text-truncate">{{ work.works_details_title }}</div>
          <div class="subheading text-truncate">{{ work.works_details_introduction }}</div>
      </v-card>
      </v-flex>
    </v-layout>

    <div class="text-xs-center" v-if="length > 1">
      <v-pagination
        v-model="page"
        :length="length"
        total-visible=5
        color="#000"
        @input="nextPage"
      ></v-pagination>
    </div>

  </v-container>
</template>
<style>
.work-detail-img {
  background-color: #FFFFFF;
}
.creators-name {
  font-family: myriad-pro, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 48px;
}
.creators-detail {
  font-size: 14px;
  margin-top: 20px;
  white-space: pre-wrap;
}
</style>
<script>
  export default {
    data() {
      return {
        page: 1,
        length: 0,
        creator: {},
        creators_img: "",
        works: [],
        work: {},
        works_details_img: "",
        detail: false
      }
    },
    created() {
      this.$emit('getAuth');
      this.getCreator();
      this.getWorks();
    },
    computed: {
      locale: {
        get:function () { return this.$store.state.locale }
      }
    },
    watch: {
      locale: function() {
        this.getCreator();
        this.getWorks();
      }
    },
    methods: {
      nextPage(page) {
        this.page = page;
        this.getWorks(true);
      },
      getCreator() {
        this.$axios.get("/service/api/public/creator/" + this.$route.params.creators_id)
          .then(response =>  {
            this.creator = response.data.creator;
            this.creators_img = '/service/img/public/creators/' + this.creator.creators_img;
          }).catch(error => {
            this.message = error.response.data.error.message;
            this.snackbar = true;
          });
      },
      getWorks(scrollTop) {
        this.$axios.get("/service/api/public/works_by_creator/" + this.$route.params.creators_id + "/" + this.page)
          .then(response =>  {
            this.works = response.data.works;
            this.length = response.data.length;
            if(scrollTop) {
              window.scroll(0, 0);
            }
          }).catch(error => {
            this.message = error.response.data.error.message;
            this.snackbar = true;
          });
      },
      addItemToCart(works_id) {
        const params = new URLSearchParams();
        params.append("works_id", works_id);
        params.append("ss_csrf_token", this.getToken());
        this.$axios
          .post("/service/api/public/itemtocart", params)
          .then(response => {
            this.detail = false;
            this.$emit('showNotification', 'success', this.$t("add-item-to-cart"));
            this.$emit('getItemsFromCart');
          }).catch(error => {
            this.$emit('showNotification', 'error', error.response.data.error.message);
          });
      },
      openDetail(key) {
        this.work = this.works[key];
        this.works_details_img = '/service/img/public/works/' + this.work.works_img;
        this.detail = true;
      }
    }
  }
</script>